
<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Medical Suppliers Master Data</h1>
          <p>Enter Medical Suppliers Master Data below to stay updated </p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>

          </div>
  </div>
</section>
<div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <div class="wrapper">
        <div class="d-grid doctor-appointment">
            <div class="appointment-form">
                <form action="#" method="post">
                    <div class="fields-grid">

                      <div class="styled-input">
                        <label>Supplier ID</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialog()" ></span>
                            <input type="text" name="doctorId" placeholder="Supplier ID" maxlength="15ch" [(ngModel)]="supCode" (change)="retriveSupplies()" required="" style="width: 30%;">

                        </div>
                      </div>
                      <div class="styled-input">
                            <label>Supplier Name</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-user" aria-hidden="true"></span>
                                <input type="text" name="fullname" maxlength="50ch" placeholder="Full Name" [(ngModel)]="supName"required="">

                              </div>
                      </div>
                      <div class="styled-input">
                        <label>Address</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-map-marker" aria-hidden="true"></span>
                            <input type="text" name="address" placeholder="Address" maxlength="100ch" [(ngModel)]="supAddress"required="">

                          </div>
                  </div>
                        <div class="styled-input">
                            <label>Phone Number</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-phone" aria-hidden="true"></span>
                                <input type="text" name="phone" maxlength="100ch" [(ngModel)]="supNotes" placeholder="Enter Number" required="">
                            </div>
                        </div>

                      <div class="styled-input">
                            <label>Classification</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-building-o" aria-hidden="true"></span>
                                <select id="classC" name="classC" required="" [(ngModel)]="supGroup" [value]="supGroup">
                                    <option value="{{cls.clasCCode}}" *ngFor="let cls of classificationCList; let i = index">{{cls.clasCName}}</option>

                                  </select>
                            </div>
                        </div>



                        <button type="button" class="theme-button btn" name="submit" (click)="submitSupplies()">Submit</button>
                        <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()">Delete</button>
                        <button type="button" class="theme-button btn" name="New" (click)="NewData()">New</button>
                        <a href="Home">
                         <button type="button" class="theme-button btn" style="width: 83%;" name="Back">Home</button>
                        </a>
                        <div class="clear"> </div>
                    </div>
                </form>
            </div>

            <div class="registerimg">
              <div class="clear"> </div>
                <img src="assets/images/slide2.jpg" alt="" />
            </div>
        </div>
        <div class="clear"> </div>
    </div>
</section>
</div>
